export default __webpack_public_path__ + "static/media/bra-note.4a925694.webp";